import { looksLikeOpaqueUserId } from "@sd/lib/ticketRowMapping";

/** Normalize multi-select filter values (dedupe, drop blanks). */
export function normalizeMultiFilterValues(values: string[]): string[] {
  return [...new Set(values.map(v => v.trim()).filter(Boolean))];
}

/** Never surface raw UUIDs in filter UI — use option label or a generic fallback. */
export function resolveFilterOptionLabel(
  value: string,
  options: { value: string; label: string }[],
  fallback = "Selected"
): string {
  const label = options.find(o => o.value === value)?.label?.trim();
  if (label) return label;
  if (looksLikeOpaqueUserId(value)) return fallback;
  return value;
}

/** Comma-separated values on one param (ticket_create API). */
export function multiValueApiParam(
  field: string,
  values: string[]
): Record<string, string> {
  const unique = normalizeMultiFilterValues(values);
  if (unique.length === 0) return {};
  return { [field]: unique.join(",") };
}

/** @deprecated Prefer `multiValueApiParam` for ticket_create list filters. */
export function multiFilterToApiParams(
  field: string,
  values: string[]
): Record<string, string> {
  return multiValueApiParam(field, values);
}

export function matchesMultiFilterValue(
  value: string | undefined | null,
  selected: string[]
): boolean {
  const unique = normalizeMultiFilterValues(selected);
  if (unique.length === 0) return true;
  const normalized = String(value ?? "").trim();
  if (!normalized) return false;
  return unique.includes(normalized);
}

export function formatMultiFilterTriggerLabel(
  values: string[],
  options: { value: string; label: string }[],
  placeholder: string
): string {
  const unique = normalizeMultiFilterValues(values);
  if (unique.length === 0) return placeholder;
  if (unique.length === 1) {
    return resolveFilterOptionLabel(unique[0], options, placeholder);
  }
  return `${unique.length} selected`;
}
